import Axios from 'axios';
import { contentInstanse } from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export async function fetchStories(params = {}, rest = {}) {
    return contentInstanse
        .get('public/story/', { params, ...rest })
        .then(({ data }) => {
            if (data && typeof data === 'object' && data.items) {
                return data;
            }
            throw new ApiRequestError('Failed fetch stories: /public/story/', params);
        })
        .catch((err) => {
            throw new ApiRequestError(`Failed fetch stories: /public/story/ ${err.message}`, rest);
        });
}

export function fetchByDestinationyId(destination_id, params = {}) {
    return fetchStories({
        category_id: destination_id,
        ...params,
    });
}

export async function fetchBySlug(slug, rest = {}) {
    return contentInstanse
        .get(`public/story/${slug}`, rest)
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError(`Failed fetchBySlug: public/story/${slug}`, rest);
        })
        .catch((err) => {
            throw new ApiRequestError(
                `Failed fetchBySlug: public/story/${slug} ${err.message}`,
                rest
            );
        });
}

export function fetchByActivityId(activity_id, params = {}) {
    return fetchStories({
        activity_id,
        ...params,
    });
}

export async function fetchUserImagesBySlug(slug) {
    const rootImage = process.env.BUILD_ENV !== 'prod' ? 'image-staging' : 'image';
    return Axios.get(`https://api.tripshock.com/${rootImage}/story?parent_id=${slug}`).then(
        ({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError('Failed fetchImagesBySlug userImages: /story', slug);
        }
    );
}
